"use strict";

/**
 * Параметры элемента множественного выбора.
 *
 * @typedef {Object}  WebAccess.components.dialogs.BaseMultiSelect.multiSelectItem
 * @property {string} id Идентификатор элемента формы
 * @property {string} name Заголовок элемента формы. Значение поля обязательно должно быть установлено
 * @since 5.0.0.4211
 *
 * @example
 * var items = [
 *    { "name": "Пункт 1", "id": 1 },
 *    { "name": "Пункт 2", "id": 2 }
 * ];
 * multiDialog = new WebAccess.components.dialogs.SelectableMultiSelect(items);
 * multiDialog.show();
 */

/**
* Диалог множественного выбора.
*
* Принимает два объекта-массива, второй из которых является опциональным.
* Во время работы не исключено изменение, добавление или удаление атрибутов или содержимого массивов.
* Поведение событий диалога ok и selectComplete отднотипно.
* Отличие в том, что событие ok срабатывает, если объекты для множественного выбора не меняются.
*
* @class WebAccess.components.dialogs.BaseMultiSelect
* @extends WebAccess.components.dialogs.BaseDialog

* @param {array<WebAccess.components.dialogs.BaseMultiSelect.multiSelectItem>} availableItems Список доступных элементов, в том числе элементы, которые были выбраны. Отображается в левой части окна
* @param {array<WebAccess.components.dialogs.BaseMultiSelect.multiSelectItem>} [opt_selectedItems] Список выбранных элементов. Отображается в правой части окна
* @param {object} [opt_settings] Настройки модального окна
* @property {string} className Имя текущего класса
* @property {boolean} isReadonly Признак того, что содержимое недоступно для изменения
* @property {string} defaultRecordIcon Иконка элемента списка доступных элементов
* @property {string} defaultMarkedRecordIcon Иконка выбранного элемента
* @property {string} isSelectionChanged Признак того, что список выбранных элементов изменился
* @property {string} filterPlaceholder Текст подсказки для фильтрации
* @property {string} filteredItemsEmptyPlaceholder Текст, отображаемый в случае, если после фильтрации элементы отсутствуют в списке
* @throws ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED – заданы не все обязательные параметры.
* @since 5.0.0.4000
* @example
* var items = [{id:"1", name: "firstItem"},
*              {id:"2", name: "secondItem"}];
* var dialog = new WebAccess.components.dialogs.BaseMultiSelect(items);
*     dialog.bind("ok", function(data) {console.log(data);});
*     dialog.show();
*/
(function (global) {
  var BaseMultiSelect = global.BaseDialog.extend({

    title: L("MODAL_DIALOG_SELECT_ITEMS"),
    width: 925,
    height: 450,
    availableItemslabel: L("MODAL_DIALOG_ALL_ITEMS"),
    selectedItemslabel: L("MODAL_DIALOG_SELECTED_ITEMS"),
    filterPlaceholder: L("MODAL_DIALOG_SEARCH_IN_ITEMS"),
    filteredItemsEmptyPlaceholder: L("MODAL_DIALOG_NO_ITEMS"),

    className: "BaseMultiSelect",

    isReadonly: false,
    defaultRecordIcon: "referenceRecord-16",
    defaultMarkedRecordIcon: "referenceRecordSelected-16",
    isSelectionChanged: false,

    _html: "",
    _navigationKeyCodes: [27, 9, 13, 37, 38, 39, 40],
    _handlers: {},
    _jSelectedItemsTable: null,
    _jAvailableItemsList: null,
    _lastFilterValue: null,
    _displayOptions: false,
    _datatable: null,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function (availableItems, opt_selectedItems, opt_settings) {
      var instance = this;

      if (!availableItems) WebAccess.raise("ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED");
      this.availableItems = availableItems;
      this.selectedItems = opt_selectedItems || [];

      this._super(opt_settings);

      /** @this - здесь, это элемент над которым производятся манипуляции, а не контекст класса BaseMultiSelect; */
      /** Когда курсор мыши убежал с элемента из области выбранных записей */
      this._handlers._hoverItem = function (event) {
        instance._hoverItem(this);
      };
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /** Когда курсор мыши убежал с элемента из области выбранных записей */
      this._handlers._unhoverItem = function (event) {
        instance._unhoverItem(this);
      };
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /** Выбор элемента и перемещение его в список выбранных. */
      this._handlers.selectItem = function (event) {
        if (!instance.isReadonly) {
          var item = $(this);
          var id = item.attr('id');
          var field = item.attr('field');
          var name = item.find('.recordlist-item__name').text();

          var newItem = {
            id: id,
            name: '' + name,
            field: '' + field
          };

          instance._addItemToSelectedItems([newItem]);
          instance.fire("itemSelect", newItem);
        }
      };
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /** Фильтрация записей в левой части */
      this._handlers.keyPressEventHandler = function (event) {
        this._jAvailableItemsList = $('#recordsList');
        if ($.inArray(event.keyCode, instance._navigationKeyCodes) > -1) {

          if (event.keyCode == 9) {
            $(this).blur();
            var firstItem = this._jAvailableItemsList.find('div.item:visible:first');
            if (firstItem.hasClass('item')) firstItem.addClass("over");

            this._jAvailableItemsList.scrollTop(0);
            return false;
          }
          //me._NavigationKeyPressHandler(ev);
        } else {
          var placeholder = this._jAvailableItemsList.find("#empty-with-filter");

          var term = $(this).val();
          this._jAvailableItemsList.find("div.item").show().not(":Contains('" + term + "')").hide();

          if (this._jAvailableItemsList.find("div.item:visible").length === 0) {
            placeholder.removeClass("hidden");
          } else {
            placeholder.addClass("hidden");
          }
        }

        return undefined;
      };
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      this._handlers.upDownKeyNavigation = function (down) {
        this._jAvailableItemsList = $('#recordsList');
        var currentItem = instance._jAvailableItemsList.find('div.item.over:visible');
        if (currentItem.length) {
          // от текущего элемента делаем поиск в 3-х направлениях: в дочерних элементах, в следующих элементах на уровень выше и в элементах того же уровня
          var nextItem;
          if (down) {
            nextItem = currentItem.find('.item:visible:first,.recordGroup:visible:first').first();
            if (nextItem.length === 0) { // если не нашли внизу
              nextItem = instance._findSiblingOrParent(currentItem, down);
            }
            if (nextItem.html() === currentItem.parent().html()) {
              nextItem = currentItem;
            }
          }
          else {
            nextItem = instance._findSiblingOrParent(currentItem, down);
          }
          if (nextItem.length) {
            currentItem.hasClass('item') ? instance._unhoverItem(currentItem) : instance.UnhoverGroup(currentItem);
            nextItem.hasClass('item') ? instance._hoverItem(nextItem) : me.HoverGroup(nextItem);
            instance._scrollListToHoveredItem(nextItem, down);
          }
        }
        else {
          var jItem;

          if (down) {
            jItem = instance._jAvailableItemsList.find('.item:visible:first,.recordGroup:visible:first').first();
            jItem.hasClass('item') ? instance._hoverItem(jItem) : instance.HoverGroup(jItem);
            instance.recordsList.scrollTop(0);
          }
          else {
            jItem = instance._jAvailableItemsList.find('.item:visible:last,.recordGroup:visible:last').last();
            jItem.hasClass('item') ? instance._hoverItem(jItem) : instance.HoverGroup(jItem);
            instance.recordsList.scrollTop(100000);
          }
        }
      };

      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
      this._handlers.rightArrowKeyPress = function () {
      };

      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
      this._handlers.leftArrowKeyPress = function () {
      };

      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
      this._handlers.deleteKeyPress = function () {
        this._jSelectedItemsTable = $('#selectedRecordsScrollArea').find('table');
        var idToRemove = instance._jAvailableItemsList.find('.item.over').attr('id');
        if (idToRemove) {
          var rowDeleteButton = instance._jSelectedItemsTable.find('tr[id=' + idToRemove + ']').find('.removeFromSelect');
          instance.deleteItemFromSelectedItemsTable(rowDeleteButton);
        }
      };

      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /** Вернем все, что навыбирали в ok callback, и еще выбросим событие с выбранными данными
      * @ignore
      */
      this.ok = this.ok.override(
        function () {
          instance.fire("ok", instance.selectedItems);
          if (this.isSelectionChanged) instance.fire("selectComplete", instance.selectedItems);
          this.superFunction(instance.selectedItems);
        }
      );
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Создание html разметки и контейнеров
    * @private
    */
    _preInit: function () {
      this._prepareAvailableItemsArea();
      this._prepareSelectedItemsArea();
    },

    /**
    * Иницииализация jQuery объектов и навешивание на них событий,
    * функция вызывается когда модальное окно и все его элементы загружены.
    * @private
    */
    _postInit: function () {
      this._jSelectedItemsTable = $('#selectedRecordsScrollArea').find('table');
      this._jAvailableItemsList = $('#recordsList');
      this._jFilterInput = $('#filterInput');
      this._initEvents();

      this._markSelectedItemsInAvailableItemsList();
      this._fixSelectedItemsTableBorder();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Подготовка области с доступными записями
    * @private
    */
    _prepareAvailableItemsArea: function () {
      var renderedItems = "";
      for (var i = 0, l = this.availableItems.length; i < l; i++) {
        this.availableItems[i]["default_icon"] = this.defaultRecordIcon;
        this.availableItems[i]["url"] = this.availableItems[i]["url"] || "#";
        renderedItems += format(CT.dialog.availableItem, this.availableItems[i]);
      }
      var isAreaReadonly = this.isReadonly ? 'readonly' : '';
      var osName = WA.ENV.os.name.toLowerCase();
      this._html = format(CT.dialog.availableItemsArea, {
        is_readonly: isAreaReadonly,
        label: this.availableItemslabel,
        tooltip: L("NAME"),
        redaonly_attr: "",
        data: renderedItems,
        placeholder_message: this.filteredItemsEmptyPlaceholder,
        tabindex: (osName === 'ios' || osName == 'android') ? 'tabindex = "-1"' : ''
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отметить выбранные записи(те что во втором массиве) галочкой.
    * Использутся только после показа модального окна.
    * @private
    */
    _markSelectedItemsInAvailableItemsList: function () {
      var selItems = this.selectedItems;
      for (var i = 0, len = selItems.length; i < len; i++) {
        this._markRecord(selItems[i].id, true);
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Строит html для области с выбранными записями.
    * @private
    */
    _prepareSelectedItemsArea: function () {
      var renderedItems = "";

      for (var i = 0, l = this.selectedItems.length; i < l; i++) {
        var selected = this._renderSelectedItem(this.selectedItems[i]);
        renderedItems += selected;
      }

      var displayDelete = this.isReadonly ? 'hidden' : '';
      var displayOptions = !this._displayOptions || this.isReadonly ? 'hidden' : '';

      this._html += format(CT.dialog.selectedItemsArea, {
        label: this.selectedItemslabel,
        extra_attributes: "",
        name: L("NAME"),
        data: renderedItems,
        display_delete: displayDelete,
        display_options: displayOptions,
        option_name: "",
        area_class: 'stat_SelectedItems'
      });

    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Создание html представления для элемента массива выбранных пунктов {id:"", name: ""};
    * @private
    */
    _renderSelectedItem: function (item) {
      item["display_delete"] = this.isReadonly ? 'hidden' : '';
      item["delete_title"] = L("DELETE");
      item["url"] = item["url"] || "#";
      item["display_options"] = 'hidden';
      item["name"] = escapeHtml(item["name"]);
      return format(CT.dialog.selectedItem, item);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Вызывается сразу после открытия модалки, навешивает события на эелементы списков
    * @private
    */
    _initEvents: function () {
      this._initSelectedItemsEvents();
      this._InitAvailableItemsListEvents();
      this._initFilterInputEvents();

      this.bind("itemSelect", function () {
        this.isSelectionChanged = true;
      });
      this.bind("itemUnSelect", function () {
        this.isSelectionChanged = true;
      });

      this._initExtraEvents();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Чтобы переопределять в наследниках
    * @private
    */
    _initExtraEvents: function() {

    },

    /**
   * Вызывается сразу после открытия модалки, навешивает события на эелементы списков
   * @private
   */
    _initFilterInputEvents: function () {
      var instance = this;

      this._jFilterInput.bind('keypress keyup', instance._handlers.keyPressEventHandler);
      if (WA.ENV.isAndroid()) { this._jFilterInput.bind('change', instance._handlers.keyPressEventHandler); }//на андроиде так
      if (WA.ENV.os.name.toLowerCase() === 'ios') {
        this._jFilterInput.blur();
      }
      this._InitKeyNavigation();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Если только на чтение, то запрещаем выбирать записи.
    * Для айпада отключаем ховеры
    * @private
    */
    _InitAvailableItemsListEvents: function (block, isNeedProcessChild) {
      var instance = this;
      var _hoverItem = function () { this._handlers._hoverItem(this); };
      var _unhoverItem = function () { this._handlers._unhoverItem(this); };

      var items = $([]); // = block ? block.find('div.item') : me.recordsList.find('div.item');

      items = this._jAvailableItemsList.find('div.item');

      if (!this.isReadonly) {
        items.on('click.MultiSelectModalWindow', instance._handlers.selectItem);

        if (!$.ipad && !WA.ENV.isAndroid()) { //
          items.hover(this._handlers._hoverItem, this._handlers._unhoverItem);
        }
        //me._InitScrollForTouchScreens();
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * @private
    */
    _getColumnsInfo: function() {
      var cols = [];
      // Колонка для удаления выбранной записи.
      if (!this.isReadonly) {
        var colWidth = WA.ENV.isMobile() ? '20px' : '15px';
        cols.push({ "sWidth": colWidth, "bVisible": true, "bSortable": false });
      } else {
        cols.push({ "bVisible": false, "bSortable": false });
      }
      // Колонка "Наименование"
      cols.push({ "bVisible": true, "sWidth": '400px', "bSortable": false });
      // Скрытая опциональная колонка
      if (!this.isReadonly && this._displayOptions) cols.push({ "bVisible": false, "sWidth": "0", "bSortable": false });
      else cols.push({ "bVisible": false, "bSortable": false });
      return cols;
    },

    /**
    * Установка событий для контролов выбранных элементов
    * @private
    */
    _initSelectedItemsEvents: function () {
      var cols = this._getColumnsInfo();
      this._datatable = this._jSelectedItemsTable.dataTable({
        "sScrollY": (this._jSelectedItemsTable.parent().height() - 38) + 'px',
        "bAutoWidth": false,
        "bDeferRender": true,
        "bPaginate": false,
        "bSortable": false,
        "oLanguage": { "sZeroRecords": L("EMPTY") },
        'aoColumns': cols
      });

      if (WA.ENV.isAndroid() || $.ipad) {
        var tableWidth = 489;
        this._jSelectedItemsTable.width(tableWidth);
        $('.dataTables_scrollHeadInner').width(tableWidth).children('table').width(tableWidth);
      } else {
        // dataTable пересчитывает ширину таблицы, приходится исправлять на 100%
        $('.dataTables_scrollHeadInner').width('100%').children('table').width('100%');
      }

      var instance = this;
      this._jSelectedItemsTable.find('tr').each(function () { instance._initSingleSelectedItemEvents(this); });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Навешивание обработчков событий на конкретный элемент списка выбранных записей
    * @private
    */
    _initSingleSelectedItemEvents: function (row) {
      row = $(row);
      var instance = this;

      if (!$.ipad && !WA.ENV.isAndroid()) {
        row.hover(
            function () { instance._jSelectedItemsTable.find("tr").not(this).trigger("mouseout"); $(this).addClass('over'); },
            function () { $(this).removeClass('over'); });
      }
      row.find('.removeFromSelect').on('click.MultiSelectModalWindow', this, function (e) {
        e.data.deleteItemFromSelectedItemsTable(this);
      });

      // Навешивает события для отображения подсказок.
      //this._initHintEvents(row);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Удаление элемента из списка выбранных записей, и из массива который был передан в конструктор.
    * @private
    */
    deleteItemFromSelectedItemsTable: function (item) {
      // Если только для чтения, запрещаем удалять выбранные записи.
      if (!this.isReadonly) {
        var row = $(item).parent().parent();

        var id = row.attr('id');

        var idx = this._getSelectedItemById(id);

        if (idx !== -1) {
          this.selectedItems.splice(idx, 1);
        }

        this.fire('itemUnSelect', id);
        //row.remove();
        this._datatable.fnDeleteRow(row[0]);
        this._markRecord(id, false);
        this._fixSelectedItemsTableBorder();
        this._addPlaceholderIfTableIsempty();

      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /** Поиск элемента среди выбранных по id
    * @param {string} id - идентификатор элемента
    * @return {integer} индекс выбранного элемента в массиве
    * @private
    * @function WebAccess.components.dialogs.BaseMultiSelect#_getSelectedItemById
    */
    _getSelectedItemById: function (id) {
      return getElementIndexByAttr(this.selectedItems, "id", id);
    },

    /** Поиск элемента среди доступных по id
    * @param {string} id - идентификатор элемента
    * @private
    * @return {object} объект выбранного элемента
    * @function WebAccess.components.dialogs.BaseMultiSelect#_getSelectedItemById
    */
    _getAvailableItemById: function (id) {
      return this.availableItems[getElementIndexByAttr(this.availableItems,"id", id)];
    },

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Пометка элемента "выбранным" или наоборот, не выбранным если второй аргумент false.
    * @private
    * @param {string} id идентификатор
    * @param {boolean} mark если true то элемент выделяется как выбранный, и наоборот.
    */
    _markRecord: function (id, mark) {
      if (id) {
        var item = this._jAvailableItemsList.find('.item[id="' + id + '"]');
        var icon = item.find('.recordlist-item__icon > use');
        var iconImage;
        if (this.treeMode) {
          iconImage = (item.hasClass('favorite')) ? this.favoriteUserIconClass : this.treeModeRecordIconClass;
        }
        else {
          iconImage = this.defaultRecordIcon;
        }
        if (mark) {
          item.addClass('selected');
          if (this.treeMode) {
            icon.removeClass(this.treeModeRecordIconClass).removeClass(this.favoriteUserIconClass);
            iconImage = this.treeModeMarkedRecordIconClass;
          } else {
            iconImage = this.defaultMarkedRecordIcon;
          }
        }
        else {
          item.removeClass('selected');
        }
        icon.attr('xlink:href', '#' + iconImage);
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Вставляет сообщение в таблицу, если нет ни одного элемента для отображаения.
    * (Сейчас по всей видимости за это отвечает параметр у datatable, а здесь просто отключается кнопка)
    * @private
    */
    _addPlaceholderIfTableIsempty: function () {
      var jRows = this._jSelectedItemsTable.children('tbody').find('tr');

      if (jRows.length === 1) {
        if (jRows.first().children("td").hasClass("dataTables_empty")) {
          this.disableButton("modal_ok_button");
        }
      }
      //var colsCount = 3;
      //var emptyRow = $(format(CT.dialog.emptyPlaceholder, { message: L('EMPTY'), cols_count: colsCount }));
      //this._jSelectedItemsTable.append(emptyRow);
      //this._InitSingleSelectedRecordEvents(emptyRow);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Используется для динамического добавления новой записи.
    * @private
    */
    _InitSingleSelectedRecordEvents: function (row) {
      row = $(row);
      if (!$.ipad && !WA.ENV.isAndroid()) {
        row.hover(
            function () { $(this).addClass('over').find('.removeFromSelect').css('visibility', 'visible'); },
            function () { $(this).removeClass('over').find('.removeFromSelect').css('visibility', 'hidden'); });
      }
      else {
        row.find('.removeFromSelect').css('visibility', 'visible');
      }
      row.find('.removeFromSelect').on('click.MultiSelectModalWindow', this, function (e) {
        e.data.DeleteItemFromSelection(this);
      });

      // Навешивает события для отображения подсказок.
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _setupKeyScope: function() {
    },

    /**
    * Добавлем бордер к div в которой находится таблица.
    * @private
    */
    _fixSelectedItemsTableBorder: function () {
      var p = this._jSelectedItemsTable.parent();
      if (this._jSelectedItemsTable.height() > p.height()) {
        p.addClass('fixBorderBottom');
      } else {
        p.removeClass('fixBorderBottom');
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Выбрать элемент.
    *
    * @param {object} item Выбранный элемент
    * @function WebAccess.components.dialogs.BaseMultiSelect#selectItem
    * @returne {WebAccess.components.dialogs.BaseMultiSelect} Объект типа BaseMultiSelect.
    */
    selectItem: function (item) {
      this.selectedItems.push(item);

     this._markRecord(item.id, true);
     return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _hoverItem: function (item) {
      $(item).addClass("over").find('.treeview_img_action').removeClass("hidden");
    },

    _unhoverItem: function (item) {
      $(item).removeClass('over').find('.treeview_img_action').addClass("hidden");
    },

    /**
    * Добавляет новые строки в таблицу выбранных.
    * @private
    */
    _addItemToSelectedItems: function (items) {
        var instance = this;
        var html = "";
        for (var i = 0; i < items.length; i++) {
          if (this._getSelectedItemById(items[i].id) !== -1) continue;
          items[i].name = escapeHtml(items[i].name);
          html += this._renderSelectedItem(items[i]);
          this.selectItem(items[i]);
        }
        if (!!html) {
          this._jSelectedItemsTable.find('td.dataTables_empty').parent().remove();
          this.enableButton("modal_ok_button");
          //this._jSelectedItemsTable.append(html);

          var columns = html.split(/<\/td>\s*<td/g);
          this._datatable.fnAddData([columns[0] + '</td>', '<td ' + columns[1] + '</td>', '<td ' + columns[2]]);

          var jNewRow = $("#selectedRecordsScrollArea").find("tr").not("tr[id]").last().addClass('selected-records-item').attr("id", items[0].id);
          instance._initSingleSelectedItemEvents(jNewRow);
          // dataTable неправильно пересчитывает ширину таблицы с заголовками, когда у таблицы с записями появляется скролл, приходится исправлять на 100%
          this._jSelectedItemsTable.parents('.dataTables_scroll').find('.dataTables_scrollHeadInner').children('table').width('100%');
          //this._jSelectedItemsTable.find('tr').each(function () { instance._initSingleSelectedItemEvents(this); });
          this._fixSelectedItemsTableBorder();
          this._jSelectedItemsTable.parent().scrollTop(1000000);
        }
      },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    /* НАВИГАЦИЯ КЛАВИАТУРОЙ */
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    _InitKeyNavigation: function () {
      if (!this.isReadonly) {
          var instance = this;
          var scope = 'modalwindow';
          key('down', scope, function () { instance._handlers.upDownKeyNavigation(true); return false; });
          key('up', scope, function () { instance._handlers.upDownKeyNavigation(false); return false; });
          key('right', scope, function () { instance._handlers.rightArrowKeyPress(); return false; });
          key('left', scope, function () { instance._handlers.leftArrowKeyPress(); return false; });
          key('delete', scope, function () { instance._handlers.deleteKeyPress(); return false; });
          key('shift+tab', scope, function () {
            setTimeout(function () { instance._jFilterInput.focus(); }, 300);
            return false;
          });
          var selector = '.item.over';

          key('enter', scope, function () {
            var jItem = instance._jAvailableItemsList.find(selector).first();
            if (jItem.length) {
              var item = instance._getAvailableItemById(jItem.attr("id"));
              instance._addItemToSelectedItems([item]);
              instance.fire("itemSelect", item);
              return false;
            }
          });
          key.setScope(scope);
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _findSiblingOrParent: function (item, down) {
      var nextItem;
      if (down) {
        nextItem = item.next('div:visible:first'); // ищем след элемент на этом же уровне
        if (nextItem.length === 0) { // если не нашли
          if (!item.parent('#recordsList').length) { // и если родительский элемент это не все дерево, и значит есть куда подниматься выше
            nextItem = this._findSiblingOrParent(item.parents('div:visible:first'), down); // ищем сиблингов у родителя или его родителей
          }
          else {
            nextItem = item;
          }
        }
      }
      else { // движение вверх
        nextItem = item.prev('div:visible:first'); // ищем сперва сиблинга
        var sibling = true;
        if (nextItem.length === 0) { // если его не нашли и родительский элемент не само дерево, и значит есть куда подниматься выше
          if (!item.parent('#recordsList').length) {
            nextItem = item.parents('div:visible:first'); // то берем родителя
            sibling = false;
            if (nextItem.length === 0) { // если его не нашли, то пытаемся найти сиблинга родителя или его родителей
              nextItem = this._findSiblingOrParent(item.parents('div:visible:first'), down);
            }
          }
          else { // если родитель - это все дерево, то мы на крайнем элементе и никуда не двигаемся
            nextItem = item;
            sibling = false;
          }
        }
        if (sibling) { // если нашли сиблинга, то проверяем наличие дочерних узлов и переходим к ним
          var subItem = nextItem.find('.item:visible:last,.recordGroup:visible:last').last();
          if (subItem.length) {
            nextItem = subItem;
          }
        }
      }
      if (nextItem.length && !nextItem.hasClass('item') && !nextItem.hasClass('recordGroup')) {
        nextItem = item;
      }
      return nextItem;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _scrollListToHoveredItem: function (item, down) {
      var instance = this;
      if (instance._getItemsListHeight() > instance._jAvailableItemsList.height()) {
        var itemHeight = 20;
        var height = 0;
        var currentID = item.attr('id');
        var items = instance._jAvailableItemsList.find('div.item:visible,div.recordGroup:visible');
        var i;

        if (down) {
          for (i = items.length - 1; i >= 0; i--) {
            if ($(items[i]).attr('id') == currentID) {
              height += (i + 1) * itemHeight;
              break;
            }
          }
          if (instance._jAvailableItemsList.height() - height < 50) {
            instance._jAvailableItemsList.scrollTop(instance._jAvailableItemsList.scrollTop() + itemHeight);
          }
        }
        else {
          for (i = 0; i < items.length; i++) {
            if ($(items[i]).attr('id') == currentID) {
              height += (i + 1) * itemHeight;
              break;
            }
          }
          if (height - instance._jAvailableItemsList.scrollTop() < 50) {
            instance._jAvailableItemsList.scrollTop(instance._jAvailableItemsList.scrollTop() - itemHeight);
          }
        }
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _getItemsListHeight: function () {
      var height = 0;
      var items = this._jAvailableItemsList.children();
      for (var i = 0; i < items.length; i++) {
        height += $(items[i]).height();
      }
      return height;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    show: function () {
      this._preInit();
      this.html = this._html;
      this._super();
      this._postInit();
      return this;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });


  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Регистронезависимый селектор :Contains
  * с лайк поиском (((
  * @inner
  */
  jQuery.expr[':'].Contains = function (a, i, m) {
    var words = m[3].toUpperCase().split(" ");
    var matches = 0;
    if (words.length > 10) return false; //Много слов - большие затупы. Цикл же.

    for (var n = 0; n < words.length; n++) {
      if (jQuery(a).text().toUpperCase().indexOf(words[n]) >= 0) matches += 1;
      if (matches == words.length) return true;
    }

    return matches == words.length;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  global.BaseMultiSelect = BaseMultiSelect;
})(window.WebAccess.components.dialogs);
